module.exports = __webpack_public_path__ + "img/list_outlined_32.c9f4b82b.svg";